import SimpleSign from './SimpleSign';

export default SimpleSign;
